import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/RankingPage.css';
import PublicNav from '../components/PublicNav';

function RankingPage() {
  const [rangliste, setRangliste] = useState(null);
  const [rankingGruppe, setRankingGruppe] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const fetchRangliste = async () => {
      try {
        const jahreRes = await fetch('/api/saisonrangliste/public/jahre');
        if (!jahreRes.ok) return;
        const jahreData = await jahreRes.json();
        const jahre = jahreData.jahre || [];
        if (jahre.length === 0) return;
        const latestJahr = jahre[jahre.length - 1];
        const res = await fetch(`/api/saisonrangliste/public/${latestJahr}`);
        if (!res.ok) return;
        const data = await res.json();
        if (data.success && data.einstellungen?.veroeffentlicht) {
          setRangliste({ ...data, jahr: latestJahr });
        }
      } catch (err) {
        console.error('Fehler beim Laden der Rangliste:', err);
      } finally {
        setLoaded(true);
      }
    };
    fetchRangliste();
  }, []);

  return (
    <div className="rp-page">
      {/* Background */}
      <div className="rp-bg-wrap">
        <img src="/ranking-bg.webp" alt="" className="rp-bg-img" />
        <div className="rp-bg-dim" />
      </div>

      <PublicNav />

      {/* Content */}
      <div className="rp-content">
        <div className="rp-header">
          <h1 className="rp-title">RANKING <span>{rangliste?.jahr || currentYear}</span></h1>
          <p className="rp-subtitle">LEISTUNG, DIE ZÄHLT</p>
        </div>

        {loaded && (
          <>
            {rangliste?.gruppen?.length > 1 && (
              <div className="rp-tabs">
                {rangliste.gruppen.map((g, i) => (
                  <button
                    key={g.id}
                    className={`rp-tab${rankingGruppe === i ? ' active' : ''}`}
                    onClick={() => setRankingGruppe(i)}
                  >
                    {g.name}
                  </button>
                ))}
              </div>
            )}

            <div className="rp-table-wrap">
              {!rangliste && (
                <div className="rp-no-data">
                  <span className="rp-no-data-icon">🏆</span>
                  <p className="rp-no-data-title">Saison {currentYear} startet bald</p>
                  <p className="rp-no-data-sub">Nach dem ersten Turnier erscheinen hier die aktuellen Punktestände aller Athleten.</p>
                </div>
              )}
              <table className="rp-table" style={!rangliste ? { opacity: 0.25, pointerEvents: 'none' } : {}}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Verein</th>
                    <th>Punkte</th>
                    <th>Siege</th>
                    <th>Podien</th>
                    <th>Starts</th>
                  </tr>
                </thead>
                <tbody>
                  {rangliste ? (
                    (rangliste.gruppen?.[rankingGruppe]?.rangliste || []).slice(0, 20).map((entry, i) => (
                      <tr key={i} className={i < 3 ? `rp-top${i + 1}` : ''}>
                        <td className="rp-pos">
                          {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : <span className="rp-pos-num">{entry.rang}</span>}
                        </td>
                        <td className="rp-name">{entry.vorname} {entry.nachname}</td>
                        <td className="rp-verein">{entry.verein_name}</td>
                        <td className="rp-punkte">{entry.punkte}</td>
                        <td className="rp-num">{entry.siege}</td>
                        <td className="rp-num">{entry.podien}</td>
                        <td className="rp-num">{entry.teilnahmen}</td>
                      </tr>
                    ))
                  ) : (
                    Array.from({ length: 10 }, (_, i) => (
                      <tr key={i}>
                        <td className="rp-pos"><span className="rp-pos-num">{i + 1}</span></td>
                        <td className="rp-name"><span className="rp-placeholder" /></td>
                        <td className="rp-verein"><span className="rp-placeholder" style={{ width: '55%' }} /></td>
                        <td className="rp-punkte">—</td>
                        <td className="rp-num">—</td>
                        <td className="rp-num">—</td>
                        <td className="rp-num">—</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default RankingPage;
